import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildAuthRequestHeaders } from "./authRequestHeaders";

export async function fetchUserProfile() {
  const { data } = await axios.get(`${getApiBase()}/me/profile`, { headers: buildAuthRequestHeaders() });
  return data;
}

export async function patchUserProfile(body) {
  const { data } = await axios.patch(`${getApiBase()}/me/profile`, body, {
    headers: buildAuthRequestHeaders(),
  });
  return data;
}

export async function postChangePassword(body) {
  const { data } = await axios.post(`${getApiBase()}/auth/change-password`, body, {
    headers: buildAuthRequestHeaders(),
  });
  return data;
}
